import { Suspense } from "react";
import { useSuspenseQuery } from "@tanstack/react-query";
import { ArrowUpRight, ShieldCheck, RefreshCw } from "lucide-react";
import { fyndanuListingsQuery } from "@/components/FyndanuGrid";

const STORE_URL =
  "https://www.fyndanu.se/butik/e435da0b-10d0-46fa-a389-702295c89840";

function Count() {
  const { data } = useSuspenseQuery(fyndanuListingsQuery);
  return <span className="tabular-nums font-semibold">{data.items.length}</span>;
}

/** Compact trust row shown directly above FyndanuGrid. */
export function FyndanuTrustRow() {
  return (
    <div className="mb-6 flex flex-col items-start justify-between gap-3 rounded-2xl border border-border bg-card px-5 py-4 md:flex-row md:items-center">
      <div className="flex flex-wrap items-center gap-x-5 gap-y-2 text-xs md:text-sm">
        <span className="inline-flex items-center gap-2 font-semibold text-accent">
          <span className="relative flex h-2 w-2">
            <span className="absolute inline-flex h-full w-full animate-ping rounded-full bg-accent opacity-70" />
            <span className="relative inline-flex h-2 w-2 rounded-full bg-accent" />
          </span>
          Live-flöde
        </span>
        <span className="text-muted-foreground">
          Officiell Fyndanu-butik ·{" "}
          <Suspense fallback={<span className="tabular-nums font-semibold">–</span>}>
            <Count />
          </Suspense>{" "}
          aktiva annonser
        </span>
        <span className="hidden items-center gap-1.5 text-muted-foreground md:inline-flex">
          <ShieldCheck size={14} className="text-accent" /> Kontrollerade fordon
        </span>
        <span className="hidden items-center gap-1.5 text-muted-foreground md:inline-flex">
          <RefreshCw size={14} className="text-accent" /> Uppdateras dagligen
        </span>
      </div>
      <a
        href={STORE_URL}
        target="_blank"
        rel="noopener noreferrer"
        className="group inline-flex items-center gap-1.5 text-xs font-semibold text-accent hover:underline underline-offset-4 md:text-sm"
      >
        Öppna butiken på Fyndanu
        <ArrowUpRight size={14} className="transition group-hover:-translate-y-0.5 group-hover:translate-x-0.5" />
      </a>
    </div>
  );
}
